import React from 'react';
import SbEditable from 'storyblok-react';
import {
  BlokComponent,
  StoryblokColor,
  StoryblokLink,
} from '../../../types/blok.model';
import { ButtonSize, ButtonType } from '../../components/Button';
import CallToAction from './index';

type CTABlokSchema = {
  bgColor: StoryblokColor;
  textColor: StoryblokColor;
  variant: ButtonType;
  size: ButtonSize;
  text: string;
  target: StoryblokLink;
};

const CallToActionBlock: BlokComponent<CTABlokSchema> = ({ blok }) => {
  const isInternalLink = blok.target.linktype === 'story';
  const href = isInternalLink ? `${blok.target.cached_url}` : blok.target.url;

  return (
    <SbEditable content={blok}>
      <CallToAction size={blok.size} link={href} title={blok.text} />
    </SbEditable>
  );
};

export default CallToActionBlock;
